import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { GET_USERS, GET_USER_BRANCHES, SAVE_ASSET_INVENTORY_USER_BRANCHES, GET_USER_EQUIPEMENT_ORDERER_ROLE, GET_USERS_BY_EMP_ID, SAVE_USER_PROFILE_PERSONAL_INFO, SAVE_USER_PROFILE_BRANCHES, SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION, UPLOAD_USER_PROFILE_IMAGE } from 'Store/Identity/UserProfiles/UserProfileTypes';
import { setUsers, setUserBranches, saveUserBranchSuccess, setUserProfileImage } from 'Store/Identity/UserProfiles/UserProfileAction'
import UserManagementApiService from 'client/utils/clientApiHelper'
import userProfileActions from '../../redux/UserProfile/actions'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getUsers(data: any): any {
    try {
        yield put(globalLoaderText("Fetching Users Data...."));
        let payloadData : IPayload= {
            apiType : apiType.Identity,
            endpoint : `users/userslist?searchText=${data?.searchString}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setUsers(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setUsers([]))
        yield put(globalLoaderText(""));
    }
}

function* getUsersBranches(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Users Data...."));
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : `userprofile/AssetInventoryAdmin/${req.emailId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setUserBranches(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setUserBranches([]))
        yield put(globalLoaderText(""));
    }
}

function* saveUserBranches(req: any): any {
    try {
        yield put(globalLoaderText("Saving Users Data...."));
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : `userprofile/AssetInventoryAdmin`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp,
            payloadData
        );
        if (response) {
            yield put(saveUserBranchSuccess('success'));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(saveUserBranchSuccess('failed'))
        yield put(globalLoaderText(""));
    }
}

function* getUserEquipmentOrdererRole(req: any): any {
    try {
        const { emailId } = req;
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : `userprofile/user/${emailId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData);
        yield put(userProfileActions.setUserDetails(response));
        yield put(userProfileActions.SetBranch(response.branches));
    } catch (error) {
        yield put(userProfileActions.setUserDetails({}));
    }
}

function* getUsersByEmpId(data: any): any {
    try {
        yield put(globalLoaderText("Fetching Users Data...."));
        const { searchId } = data;
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : `users/search/${searchId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setUsers(response));
            yield put(globalLoaderText(""));
        } else {
            yield put(setUsers([]));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setUsers([]))
        yield put(globalLoaderText(""));
    }
}

function* saveUserProfilePersonalInfo(req: any): any {
    try {
        yield put(globalLoaderText("Updating user profile...."));
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : req?.type == SAVE_USER_PROFILE_PERSONAL_INFO ? `userprofile/personalinfo` : `userprofile/branch`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp,
            payloadData
        );
        if (response) {      
            yield put(userProfileActions.setResultMessage('User Profile Updated Successfully'));
            yield put(globalLoaderText(""));
        } else {
            yield put(userProfileActions.setResultMessage('Something went wrong. Please try again'));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(userProfileActions.setResultMessage('Something went wrong. Please try again'));
        yield put(globalLoaderText(""));
    }
}


function* saveUserProfileNotificationSubs(req: any): any {
    try {
        yield put(globalLoaderText("Updating user profile...."));
        let payloadData : IPayload = {
            apiType : apiType.Notification,
            endpoint : `notification/notificationSubscriptions`,
            apiMethod :  apiMethod.POST,
            payload : req.payload || []
        }
        const response = yield call(
            UserManagementApiService.callNotificationPost , API_URL.PostWebApp,
            payloadData
        );
        if (response) {        
            yield put(userProfileActions.setResultMessage('User Profile Updated Successfully'));
            yield put(globalLoaderText(""));
        } else {
            yield put(userProfileActions.setResultMessage('Something went wrong. Please try again'));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(userProfileActions.setResultMessage('Something went wrong. Please try again'));
        yield put(globalLoaderText(""));
    }
}

function* setUserProfilePicture(req: any): any {
    try {
        yield put(globalLoaderText("Updating user profile picture...."));
        let formObject = req.payload
        formObject.append('apiMethod', apiMethod.POST)
        formObject.append('apiType', apiType.Identity)
        formObject.append('endpoint', `userprofile/upload/image`)
        const response = yield call(
            UserManagementApiService.callUserPost, `${API_URL.PostWebApp}/upload/attachments`,
            formObject
        );
        if (response) {      
            yield put(setUserProfileImage(response));
            yield put(globalLoaderText(""));
        } else {
            yield put(setUserProfileImage(""));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setUserProfileImage(""));
        yield put(globalLoaderText(""));
    }
}

function* watchRegion() {
    yield takeEvery(GET_USERS, getUsers);
    yield takeEvery(GET_USER_BRANCHES, getUsersBranches);
    yield takeEvery(SAVE_ASSET_INVENTORY_USER_BRANCHES, saveUserBranches);
    yield takeEvery(GET_USER_EQUIPEMENT_ORDERER_ROLE, getUserEquipmentOrdererRole);
    yield takeEvery(GET_USERS_BY_EMP_ID, getUsersByEmpId);
    yield takeEvery(SAVE_USER_PROFILE_PERSONAL_INFO, saveUserProfilePersonalInfo);
    yield takeEvery(SAVE_USER_PROFILE_BRANCHES, saveUserProfilePersonalInfo);
    yield takeEvery(SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION, saveUserProfileNotificationSubs);
    yield takeEvery(UPLOAD_USER_PROFILE_IMAGE, setUserProfilePicture);
}

export default function* combinedSaga() {
    yield all([
        watchRegion()
    ])
}